import { useState } from 'react';
import { postsModuleURL } from "src/services/urlService";
import HttpServices from 'src/services/httpService';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

const AutoPostApiHandler = ({
  showToast,
  fetchAutoPostBrandDetails,
  onLoadingChange,
  children
}) => {
  const { t: translate } = useTranslation();

  // API call wrappers
  const doStartAuto = ({ prompt, websiteUrls, locationInput, locations, ...rest }) => {
    onLoadingChange(true);
    let finalLocations = locations;
    if (locationInput && locationInput.trim()) {
      const newLocations = locationInput
        .split(',')
        .map((loc) => loc.trim())
        .filter((loc) => loc && !locations.includes(loc));
      finalLocations = [...locations, ...newLocations];
    }
    const payload = {
      ...rest,
      prompt,
      website_urls: websiteUrls,
      locations: finalLocations,
    };
    const bodyPayload = {
      auto_post_details: payload
    };
    HttpServices.Post({
      url: postsModuleURL.startAutoPost,
      body: bodyPayload,
      successCallback: (data, message) => {
       CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_AUTO_POST_STARTED)
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.auto_post_started', 'Auto Post started!'), 's');
        if (typeof fetchAutoPostBrandDetails === 'function') {
          fetchAutoPostBrandDetails();
        }
      },
      failureCallback: (message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.failed_to_start', 'Failed to start'), 'e');
      },
    });
  };

  const doPauseAutoPost = () => {
    onLoadingChange(true);
    HttpServices.Post({
      url: postsModuleURL.pauseAutoPostDetails,
      body: {},
      successCallback: (data, message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.auto_post_paused', 'Auto Post Paused'), 's');
        if (typeof fetchAutoPostBrandDetails === 'function') {
          fetchAutoPostBrandDetails();
        }
      },
      failureCallback: (message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.failed_to_pause', 'Failed to pause'), 'e');
      },
    });
  };

  const doResumeAutoPost = () => {
    onLoadingChange(true);
    HttpServices.Post({
      url: postsModuleURL.resumeAutoPostDetails,
      body: {},
      successCallback: (data, message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.auto_post_resumed', 'Auto Post Resumed'), 's');
        if (typeof fetchAutoPostBrandDetails === 'function') {
          fetchAutoPostBrandDetails();
        }
      },
      failureCallback: (message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.failed_to_resume', 'Failed to resume'), 'e');
      },
    });
  };

  const doUpdateAutoPost = (payload) => {
    onLoadingChange(true);
    const bodyPayload = {
      auto_post_details: payload
    };
    HttpServices.Post({
      url: postsModuleURL.updateAutoPostDetails,
      body: bodyPayload,
      successCallback: (data, message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.auto_post_updated', 'Auto Post updated!'), 's');
        if (typeof fetchAutoPostBrandDetails === 'function') {
          fetchAutoPostBrandDetails();
        }
      },
      failureCallback: (message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.failed_to_update', 'Failed to update'), 'e');
      },
    });
  };

  const doDeleteAutoPost = () => {
    onLoadingChange(true);
    HttpServices.Post({
      url: postsModuleURL.deleteAutoPostDetails,
      body: {},
      successCallback: (data, message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.auto_post_deleted', 'Auto Post deleted!'), 's');
        if (typeof fetchAutoPostBrandDetails === 'function') {
          fetchAutoPostBrandDetails();
        }
      },
      failureCallback: (message) => {
        onLoadingChange(false);
        showToast(message || translate('auto_post_api_handler.failed_to_delete', 'Failed to delete'), 'e');
      },
    });
  };

  // Render prop pattern for API functions
  return children({
    doStartAuto,
    doPauseAutoPost,
    doResumeAutoPost,
    doUpdateAutoPost,
    doDeleteAutoPost,
  });
};

export default AutoPostApiHandler;
